/**
 * The code below is a monkeypatch for a know issue
 * of the SVGdotJS' plugin panzoom.js
 */
// const validPreserveAspectRatio = [
//   undefined,
//   'none',
//   'xMinYMin meet',
//   'xMidYMin meet',
//   'xMaxYMin meet',
//   'xMinYMid meet',
//   'xMidYMid meet',
//   'xMaxYMid meet',
//   'xMinYMax meet',
//   'xMidYMax meet',
//   'xMaxYMax meet',
//   'xMinYMin slice',
//   'xMidYMin slice',
//   'xMaxYMin slice',
//   'xMinYMid slice',
//   'xMidYMid slice',
//   'xMaxYMid slice',
//   'xMinYMax slice',
//   'xMidYMax slice',
//   'xMaxYMax slice'
// ];

/**
 * This function is a rework and Vue-d version of
 * https://github.com/svgdotjs/svg.panzoom.js/issues/80
 * GitHUB issue and the proposed answer
 */
// const restrictedToMargins = (state, box) => {
//   const { margins, parentObj, parentEl, defaultVBox } = state.svg;
//   if (!margins) return box;

//   const { top, left, bottom, right } = margins;
//   const _this = parentObj;
//   if (!_this) return box;

//   const currentBoundingRect = parentEl.getBoundingClientRect();
//   const { width: svgWidth, height: svgHeight } = currentBoundingRect;

//   const _this$attr = _this.attr(['preserveAspectRatio']);

//   let preserveAspectRatio = _this$attr.preserveAspectRatio;
//   // const viewbox = _this.viewbox();

//   if (!validPreserveAspectRatio.includes(preserveAspectRatio)) {
//     preserveAspectRatio = undefined;
//   }

//   // The current viewport (exactly what is shown on the screen, what we ultimately want to restrict)
//   // is not always exactly the same as current viewbox. They are different when the viewbox aspectRatio and the svg aspectRatio
//   // are different and preserveAspectRatio is not "none". These offsets represent the difference in user coordinates
//   // between the side of the viewbox and the side of the viewport.
//   let viewportLeftOffset = 0;
//   let viewportRightOffset = 0;
//   let viewportTopOffset = 0;
//   let viewportBottomOffset = 0;

//   // preserveAspectRatio none has no offsets
//   if (!(typeof preserveAspectRatio !== 'undefined' && preserveAspectRatio === 'none')) {
//     const svgAspectRatio = svgWidth / svgHeight;
//     const viewboxAspectRatio = defaultVBox.width / defaultVBox.height;
//     // when aspectRatios are the same, there are no offsets
//     if (viewboxAspectRatio !== svgAspectRatio) {
//       const changedAxis = svgAspectRatio > viewboxAspectRatio ? 'width' : 'height';
//       // aspectRatio undefined is like meet because that's the default
//       if (typeof preserveAspectRatio === 'undefined' || preserveAspectRatio.includes('meet')) {
//         // in meet mode, the viewport is the viewbox, extended on one
//         // or both sides to match the aspectRatio of the svg
//         if (changedAxis === 'width') {
//           const widthOffset = (box.width / viewboxAspectRatio) * svgAspectRatio - box.width;
//           // aspectRatio undefined is like mid because that's the default
//           if (typeof preserveAspectRatio === 'undefined' || preserveAspectRatio.includes('xMid')) {
//             viewportLeftOffset = -widthOffset / 2;
//             viewportRightOffset = widthOffset / 2;
//           } else if (preserveAspectRatio.includes('xMin')) {
//             viewportRightOffset = widthOffset;
//           } else if (preserveAspectRatio.includes('xMax')) {
//             viewportLeftOffset = -widthOffset;
//           }
//         } else {
//           const heightOffset = (box.height * viewboxAspectRatio) / svgAspectRatio - box.height;
//           if (typeof preserveAspectRatio === 'undefined' || preserveAspectRatio.includes('YMid')) {
//             viewportTopOffset = -heightOffset / 2;
//             viewportBottomOffset = heightOffset / 2;
//           } else if (preserveAspectRatio.includes('YMin')) {
//             viewportBottomOffset = heightOffset;
//           } else if (preserveAspectRatio.includes('YMax')) {
//             viewportTopOffset = -heightOffset;
//           }
//         }
//       } else if (preserveAspectRatio.includes('slice')) {
//         // in slice mode, the viewport is the viewbox, shrunk on one
//         // or both sides to match the aspectRatio of the svg
//         if (changedAxis === 'width') {
//           const heightOffset = box.height - (box.height * viewboxAspectRatio) / svgAspectRatio;
//           if (preserveAspectRatio.includes('xMid')) {
//             viewportTopOffset = heightOffset / 2;
//             viewportBottomOffset = -heightOffset / 2;
//           } else if (preserveAspectRatio.includes('xMin')) {
//             viewportBottomOffset = -heightOffset;
//           } else if (preserveAspectRatio.includes('xMax')) {
//             viewportTopOffset = heightOffset;
//           }
//         } else {
//           const widthOffset = box.width - (box.width / viewboxAspectRatio) * svgAspectRatio;
//           if (preserveAspectRatio.includes('YMid')) {
//             viewportLeftOffset = widthOffset / 2;
//             viewportRightOffset = -widthOffset / 2;
//           } else if (preserveAspectRatio.includes('YMin')) {
//             viewportLeftOffset = -widthOffset;
//           } else if (preserveAspectRatio.includes('YMax')) {
//             viewportRightOffset = widthOffset;
//           }
//         }
//       }
//     }
//   }

//   // when box.x == leftLimit, the image is panned to the left,
//   // i.e the current box is to the right of the initial viewbox,
//   // and only the right part of the initial image is visible, i.e.
//   // the right side of the initial viewbox minus left margin (viewbox.x+viewbox.width-left)
//   // is aligned with the left side of the viewport (box.x + viewportLeftOffset):
//   // viewbox.width + viewbox.x - left = box.x + viewportLeftOffset
//   // viewbox.width + viewbox.x - left - viewportLeftOffset = box.x (= leftLimit)
//   const leftLimit = defaultVBox.width + defaultVBox.x - left - viewportLeftOffset;
//   // when box.x == rightLimit, the image is panned to the right,
//   // i.e the current box is to the left of the initial viewbox
//   // and only the left part of the initial image is visible, i.e
//   // the left side of the initial viewbox plus right margin (viewbox.x + right)
//   // is aligned with the right side of the viewport (box.x + box.width + viewportRightOffset)
//   // viewbox.x + right = box.x + box.width + viewportRightOffset
//   // viewbox.x + right - box.width - viewportRightOffset = box.x (= rightLimit)
//   const rightLimit = defaultVBox.x + right - box.width - viewportRightOffset;
//   // same with top and bottom
//   const topLimit = defaultVBox.height + defaultVBox.y - top - viewportTopOffset;
//   const bottomLimit = defaultVBox.y + bottom - box.height - viewportBottomOffset;

//   box.x = Math.min(leftLimit, Math.max(rightLimit, box.x)); // enforce rightLimit <= box.x <= leftLimit
//   box.y = Math.min(topLimit, Math.max(bottomLimit, box.y)); // enforce bottomLimit <= box.y <= topLimit

//   return box;
// };
/**
 * Monkeypatch ends here
 */

export default {
  setMapLoadingState(state, payload) {
    state.isLoading = payload;
  },
  setSVGParentEl(state, svgEl) {
    state.svg.parentEl = svgEl;
  },
  setSVGParentObj(state, svgObj) {
    state.svg.parentObj = svgObj;
  },
  setMinZoom(state, minZoom) {
    state.svg.minZoom = minZoom;
  },
  setZoom(state, zoomLevel) {
    state.svg.currentZoom = zoomLevel;
  },
  setVBox(state, newVBox) {
    state.svg.currentVBox = { ...newVBox }; // restrictedToMargins(state, { ...newVBox });
  },
  setActiveCountryId(state, newID) {
    state.countries.activeCountryId = newID;
  }
};
